<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    this.getConfigList('dealer_quota_report_list');
  },
  methods: {
  },
};
</script>
